import { render, staticRenderFns } from "./AdminPredefinedAnswerForm.vue?vue&type=template&id=1d1d7d61&"
import script from "./AdminPredefinedAnswerForm.vue?vue&type=script&lang=ts&"
export * from "./AdminPredefinedAnswerForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports